// /src/pages/UsageHistoryPage.jsx
import React from "react";
import styled from "styled-components";
import BrandHeader from "../components/BrandHeader";
import PageTopBar from "../components/PageTopBar";

const Wrap = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #D7E8FF 0%, #EAF3FF 100%);
  display: flex;
  flex-direction: column;
`;

const Sheet = styled.div`
  background: #F7FAFF;
  box-shadow: 0 -4px 20px rgba(0,0,0,.05);
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
`;


const Body = styled.div`
  flex: 1;
  display: grid;
  grid-template-rows: auto 1fr auto;
  row-gap: 14px;
  padding: 16px;
`;

/* 리스트 컨테이너 */
const Section = styled.section`
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 1px 10px rgba(0,0,0,.06);
  padding: 12px;
  display: grid;
  gap: 10px;
`;

/* 카드(이용내역 아이템) */
const Item = styled.div`
  background: #f8fbff;
  border-radius: 12px;
  padding: 12px 14px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  align-items: center;
  transition: transform .06s ease, box-shadow .12s ease, background .12s ease;
  &:active { transform: translateY(1px); }
`;

const ItemText = styled.div`
  display: grid;
  gap: 4px;

  .title {
    font-size: 15px;
    font-weight: 900;
    color: #0f172a;
    line-height: 1.2;
  }
  .meta {
    font-size: 12px;
    color: #64748b;
  }
`;

const RightCol = styled.div`
  text-align: right;
  display: grid;
  gap: 6px;
  justify-items: end;
`;

const Amount = styled.div`
  font-weight: 900;
  color: #0f172a;
`;

const Badge = styled.span`
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 900;
  background: ${(p) =>
        p.type === "done" ? "#EAFBEF" :
            p.type === "ongoing" ? "#FFF6D9" :
                "#FFECEC"};
  color: ${(p) =>
        p.type === "done" ? "#16794F" :
            p.type === "ongoing" ? "#6A4C0A" :
                "#A12B2B"};
  border: 1px solid ${(p) =>
        p.type === "done" ? "#CFEFDA" :
            p.type === "ongoing" ? "#F0E2B0" :
                "#F5C2C2"};
`;

const BottomPad = styled.div`
  height: max(24px, env(safe-area-inset-bottom));
`;

export default function UsageHistoryPage() {

    // ✅ 차량 관련 더미 데이터 (상세 포함)
    const items = [
        {
            id: 1,
            title: "회원 신청",
            date: "2025-09-01",
            detail: "신규 회원 가입 요청 (심사 중)",
            amount: "-",
            status: "ongoing",
        },
        {
            id: 2,
            title: "회원 승인",
            date: "2025-09-02",
            detail: "관리자 승인 완료 → 정식 회원 전환",
            amount: "-",
            status: "done",
        },
        {
            id: 3,
            title: "물품 구입",
            date: "2025-09-10",
            detail: "차량용품 세트 (폼샴푸 500ml + 극세사 타월 2장 + 유리세정제)",
            amount: "25,000원",
            status: "done",
        },
        {
            id: 4,
            title: "쿠폰 수령",
            date: "2025-09-12",
            detail: "첫 세차 5,000원 할인쿠폰 수령",
            amount: "-5,000원",
            status: "done",
        },
        {
            id: 5,
            title: "쿠폰 결제",
            date: "2025-09-15",
            detail: "셀프세차 1회 이용권(모바일 쿠폰) → 환불 처리",
            amount: "9,900원",
            status: "refund",
        },
    ];

    const statusLabel = (s) =>
        s === "ongoing" ? "진행중" : s === "done" ? "완료" : "취소/환불";

    return (
        <Wrap>
            <Sheet>
                <PageTopBar />

                <Body>
                    <BrandHeader subtitle="이용내역" />

                    <Section>
                        {items.map((it) => (
                            <Item key={it.id}>
                                <ItemText>
                                    <div className="title">{it.title}</div>
                                    <div className="meta">
                                        {it.date} · {it.detail}
                                    </div>
                                </ItemText>

                                <RightCol>
                                    <Amount>{it.amount}</Amount>
                                    <Badge type={it.status}>{statusLabel(it.status)}</Badge>
                                </RightCol>
                            </Item>
                        ))}
                    </Section>

                    <BottomPad />
                </Body>
            </Sheet>
        </Wrap>
    );
}
